/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CheckEmailResponse
 */
export interface CheckEmailResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CheckEmailResponse
     */
    _exists?: boolean;
}

/**
 * Check if a given object implements the CheckEmailResponse interface.
 */
export function instanceOfCheckEmailResponse(value: object): value is CheckEmailResponse {
    return true;
}

export function CheckEmailResponseFromJSON(json: any): CheckEmailResponse {
    return CheckEmailResponseFromJSONTyped(json, false);
}

export function CheckEmailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckEmailResponse {
    if (json == null) {
        return json;
    }
    return {
        
        '_exists': json['exists'] == null ? undefined : json['exists'],
    };
}

export function CheckEmailResponseToJSON(json: any): CheckEmailResponse {
    return CheckEmailResponseToJSONTyped(json, false);
}

export function CheckEmailResponseToJSONTyped(value?: CheckEmailResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'exists': value['_exists'],
    };
}

